import { UserVehicleInfo } from '../../../models/profile-with-vehicles';

export function buildVehicleLabel(preSelectedVehicle: UserVehicleInfo) {
    const VehicleModelAndYear =
        preSelectedVehicle.modelName + ' ' + preSelectedVehicle.modelYear;
    return preSelectedVehicle.nickName
        ? preSelectedVehicle.nickName
        : VehicleModelAndYear;
}

/**
 * Sanitizes and formats a mileage string by removing unwanted characters.
 * This implementation avoids regex DoS hotspots.
 */
export const sanitizeMileage = (mileage: string): string => {
    // Return only the digits as a string
    const sanitisedMileage = mileage.replace(/\D/g, '');
    return sanitisedMileage;
};
